import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-top"><path d="M4.29233 16.0258C3.37989 17.8513 4.70668 20 6.74799 20H17.2519C19.2932 20 20.62 17.8513 19.7076 16.0258L14.4556 5.51814C13.4439 3.49395 10.556 3.49396 9.54431 5.51814L4.29233 16.0258Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowTriangleTop;
